export default __webpack_public_path__ + "static/media/image7-2.548c0005.png";